export const getMainDomain = (hostname = globalThis.location.hostname) => {
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    // Return last two parts for standard domains
    return parts.slice(-2).join('.');
  }

  return hostname;
};

export const getTenantDomain = (hostname = globalThis.location.hostname) => {
  if (hostname === 'local.devshares.vision') {
    return 'admin.devshares.vision';
  }
  if (hostname === 'local_1.devshares.vision') {
    return 'instrive.devshares.vision';
  }
  return hostname;
};
